module.exports = __webpack_public_path__ + "logo.png?3b5781826600715cfecfe4e7ff6f494c";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 424
// module chunks = 0